const Images = {
    NoImageItem:'https://storage.googleapis.com/cubebio/default/nodata_2.svg'
}

export default Images;